import { render, staticRenderFns } from "./CMFiltersList.vue?vue&type=template&id=1f980882&scoped=true&lang=pug"
import script from "./CMFiltersList.vue?vue&type=script&lang=js"
export * from "./CMFiltersList.vue?vue&type=script&lang=js"
import style0 from "./CMFiltersList.vue?vue&type=style&index=0&id=1f980882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f980882",
  null
  
)

export default component.exports